// extracted by mini-css-extract-plugin
export var main = "service-module--main--yVByK";
export var service = "service-module--service--AHUny";